const suggestionsSorter = (s1, s2) => {
    const order = {
        contactSuggestions: 0,
        stickyNotesSuggestions: 1,
        fileSuggestions: 2,
        meetingTimeSuggestions: 3,
        vivaTopicEntitySuggestions: 4,
        vivaTopicFileSuggestions: 5,
        vivaTopicPeopleSuggestions: 6,
    };
    return order[s1[0]] - order[s2[0]];
};

export default suggestionsSorter;
